import { render, staticRenderFns } from "./DataImport.vue?vue&type=template&id=aac479cc&scoped=true&"
import script from "./DataImport.vue?vue&type=script&lang=js&"
export * from "./DataImport.vue?vue&type=script&lang=js&"
import style0 from "./DataImport.vue?vue&type=style&index=0&id=aac479cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac479cc",
  null
  
)

export default component.exports